import { object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const characterLimit = 55

const validationSchema = () => string()
  .required(I18n.t('activerecord.errors.models.event_type_base.attributes.name.blank'))
  .test('no-blank', I18n.t('activerecord.errors.models.event_type_base.attributes.name.blank'), (value) => value?.trim() !== '')
  .max(characterLimit, I18n.t('errors.messages.too_long', { count: characterLimit }))

export const getValidationSchema = () => object({
  name: validationSchema()
})
